import { connectInfiniteHits } from "instantsearch.js/es/connectors";

import { getAssetCard } from "../search-ui-utils";
import { hideLoader } from "../loader/loader.js";

const renderResults = (renderOptions, isFirstRender) => {
	const { items, isLastPage, showMore, widgetParams } = renderOptions;
	const extranetShowMoreContainer = document.querySelector(".ShowMore");
	const extranetShowMoreButton =
		extranetShowMoreContainer.querySelector("button");
	const resultsContainer = widgetParams.container;

	resultsContainer.classList.add("u-hidden");

	if (isFirstRender && extranetShowMoreButton) {
		extranetShowMoreButton.addEventListener("click", (event) => {
			event.preventDefault();
			showMore();
		});
	}

	if (items) {
		const results = items.map((item) => {
			return getAssetCard(item, /* asListItem */ true);
		});

		resultsContainer.innerHTML = ""; // Clear previous results
		resultsContainer.append(...results);

		hideLoader();
		resultsContainer.classList.remove("u-hidden");

		extranetShowMoreContainer.hidden = isLastPage;
	}
};

const customInfiniteHits = connectInfiniteHits(renderResults);

export const initExtranetResults = () => {
	const container = document.querySelector(".ExtranetResults");
	return customInfiniteHits({
		container,
	});
};
